import { BUTT_SIZE_OPTIONS } from '../BUTT_SIZE_OPTIONS';
import { ButtSizeOptionIdType } from '../types';

export const getButtSizeIdByTitle = (
  title: string | null | undefined,
): ButtSizeOptionIdType | null => {
  if (!title) {
    return null;
  }

  const option = BUTT_SIZE_OPTIONS.find(
    (option) => option.title.toLowerCase() === title.toLowerCase(),
  );

  return option?.id ?? null;
};
